import React, { Component } from "react";
import domain from "../../../../../domain.js";
import axios from "axios";
import { Table } from "semantic-ui-react";
// import 'semantic-ui-css/semantic.min.css';
import decode from "jwt-decode";
// import { Button} from 'semantic-ui-react'
import moment from "moment";
import SessionWiseFeedbackModal from "./SessionWiseFeedbackModal.js";
// import {Modal, Button } from 'react-materialize'

import { Badge } from "mdbreact";

// const color=[
//   'violet',

// ]
export default class SessionWiseFeedback extends Component {
  constructor(props) {
    super(props);
    this.state = {
      lecturer_name: "",
      topic: "",
      start_time: "",
      end_time: "",
      data: null,
      trainee_id: "",
      username: "",
      course_session_id: "",
      submission_count: 0,
      save_status: "",
      key: 0,
      modal: false,
    };
  }
  toggle = () => {
    this.setState({
      modal: !this.state.modal,
    });
  };
  updateSubmissionCount = (count) => {
    this.setState({
      submission_count: count,
    });
  };

  sessionwisedetails() {
    const { id, username } = decode(localStorage.getItem("token"));
    axios
      .get(`${domain.DBServer}/get-session-by-date/${id}`)
      .then((result) => {
        // console.log(result.data)
        this.setState({
          lecturer_name: result.data[0].lecturer_name,
          start_time: result.data[0].start_time,
          end_time: result.data[0].end_time,
          topic: result.data[0].title,
          course_session_id: result.data[0].course_session_id,
          data: result.data,
          trainee_id: id,
          submission_count: result.data[0].submission_count,
          username: username,
        });
      })
      .catch((error) => {
        console.error("error: ", error);
      });
  }

  componentDidMount() {
    this.sessionwisedetails();
    // this.feedbacksessionwise();
  }

  // forceUpdateHandler(){
  //   this.forceUpdate();
  // };

  render() {
    let sessions;
    console.log(this.state.data);
    if (this.state.data) {
      sessions = this.state.data.map((result, key) => (
        <Table.Row key={key}>
          <Table.Cell>{key + 1}</Table.Cell>
          <Table.Cell width={3}>{result.title}</Table.Cell>
          <Table.Cell width={3}>{result.lecturer_name}</Table.Cell>
          <Table.Cell width={3}>
            {moment(result.session_date).format("LL")}
          </Table.Cell>
          <Table.Cell width={2}>
            {moment(result.start_time, "h:mm a").format("HH:mm a")}
          </Table.Cell>
          <Table.Cell width={2}>
            {moment(result.end_time, "h:mm a").format("HH:mm a")}
          </Table.Cell>

          <Table.Cell>
            {result.submission_count === null ? (
              <SessionWiseFeedbackModal
                trainee_id={this.state.trainee_id}
                session={result}
                course_session_id={result.course_session_id}
                updateSubmissionCount={this.updateSubmissionCount}
                submission_count={0}
                position={key}
              />
            ) : (
              <SessionWiseFeedbackModal
                trainee_id={this.state.trainee_id}
                session={result}
                course_session_id={result.course_session_id}
                updateSubmissionCount={this.updateSubmissionCount}
                submission_count={result.submission_count}
                position={key}
              />
            )}

            {/* <Modal
              fixedFooter
              style={{width:"400",height:"400"}}
              trigger={<Button style={{backgroundColor:"#039be5"}}>FEEDBACK</Button>}

              >
            { (result.submission_count===null)
            ?<SessionWiseFeedbackModal  trainee_id={this.state.trainee_id} session={result} course_session_id={result.course_session_id} updateSubmissionCount={this.updateSubmissionCount} submission_count={0} position={key}/>
            :<SessionWiseFeedbackModal  trainee_id={this.state.trainee_id}  session={result} course_session_id={result.course_session_id} updateSubmissionCount={this.updateSubmissionCount} submission_count={result.submission_count} position={key}/>
            }
            </Modal> */}

            {result.submission_count > 0 ? (
              <Badge color="primary">submitted</Badge>
            ) : (
              <Badge color="danger">not submitted</Badge>
            )}
          </Table.Cell>
        </Table.Row>
      ));
    }
    return (
      <div className="row">
        <div className="col s12 m12">
          <div className="card ">
            <div className="card-content">
              <Table celled selectable color="violet">
                <Table.Header>
                  <Table.Row>
                    <Table.HeaderCell>S. No</Table.HeaderCell>
                    <Table.HeaderCell>Title of Lecture</Table.HeaderCell>
                    <Table.HeaderCell>Lecturer Name</Table.HeaderCell>
                    <Table.HeaderCell>Session Date</Table.HeaderCell>
                    <Table.HeaderCell>Start Time</Table.HeaderCell>
                    <Table.HeaderCell>End Time</Table.HeaderCell>

                    <Table.HeaderCell>Give Your Feedback</Table.HeaderCell>
                  </Table.Row>
                </Table.Header>

                <Table.Body>{sessions}</Table.Body>
              </Table>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
